import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
  User,
  Phone,
  MapPin,
  GraduationCap,
  Calendar,
  Hash,
  X,
  Printer,
  IndianRupee,
  IdCardLanyard,
  Clock,
  CheckCircle,
} from 'lucide-react'
import * as api from '../../app/axios/api'
import { toast } from 'sonner'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import GenerateCertificateForm from '../../components/GenerateCertificateForm'
import UpdateRegistration from '../../components/UpdateRegistion'

const Details = () => {
  const { id } = useParams()
  const [studentDetails, setStudentDetails] = useState({})
  const [studentFees, setStudentFees] = useState([])
  const [allAttendance, setAllAttendance] = useState([])
  const [loading, setLoading] = useState(true)
  const [showFeeForm, setShowFeeForm] = useState(false)
  const [showRemovedBtn, setShowRemovedBtn] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [selectedDate, setSelectedDate] = useState('')
  const [selectedTime, setSelectedTime] = useState('')
  const [isSubmittingFee, setIsSubmittingFee] = useState(false)
  // NEW: State for certificate modal
  const [showUpdateModal, setShowUpdateModal] = useState(false)
  const [showUpdateRes, setShowUpdateRes] = useState(false)
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [showCertificateModal, setShowCertificateModal] = useState(false)
  const [certificateLoading, setCertificateLoading] = useState(false)
  // State for fee update modal
  const [showFeeUpdateModal, setShowFeeUpdateModal] = useState(false)
  const [selectedFeeId, setSelectedFeeId] = useState(null)
  const [updateFeeDate, setUpdateFeeDate] = useState('')
  // Convert attendance data to FullCalendar events
  const convertToEvents = (attendanceData) => {
    return attendanceData.map((attendance) => {
      const date = new Date(attendance.created_at)
      const dateStr = date.toISOString().split('T')[0] // Get YYYY-MM-DD format
      const timeStr = date.toTimeString().split(' ')[0] // Get HH:MM:SS format

      return {
        id: attendance.id.toString(),
        title: `Present - ID: ${attendance.admission_id}`,
        start: attendance.created_at,
        backgroundColor: '#10b981', // Green for present
        borderColor: '#059669',
        textColor: 'white',
        extendedProps: {
          admission_id: attendance.admission_id,
          attendance_id: attendance.id,
          time: timeStr,
        },
      }
    })
  }

  const events = convertToEvents(allAttendance)

  // Handle event click
  const handleEventClick = (clickInfo) => {
    const event = clickInfo.event
    const props = event.extendedProps

    alert(`
      Attendance Details:
      - Attendance ID: ${props.attendance_id}
      - Admission ID: ${props.admission_id}
      - Date: ${event.start.toLocaleDateString()}
      - Time: ${props.time}
    `)
  }

  // Handle date click
  const handleDateClick = (dateClickInfo) => {
    const clickedDate = dateClickInfo.dateStr
    const attendanceOnDate = allAttendance.filter((att) => {
      const attDate = new Date(att.created_at).toISOString().split('T')[0]
      return attDate === clickedDate
    })

    // if (attendanceOnDate.length > 0) {
    //   console.log(`Attendance on ${clickedDate}:`, attendanceOnDate)
    // } else {
    //   console.log(`No attendance recorded on ${clickedDate}`)
    // }
  }

  // Updated state with payment_mode
  const [feeForm, setFeeForm] = useState({
    amount: 0,
    student_id: Number(id),
    payment_mode: 'Cash', // Default to Cash
    remark: '',
    fee_submit_date: '',
  })

  const fetchStudentDetails = async (id) => {
    try {
      setLoading(true)
      const res = await api.fetchStudentDetails(id)
      setStudentDetails(res.data)
      return res.data // Return the data to use in the next call
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const fetchStudentFees = async (id) => {
    try {
      const res = await api.fetchFees(id)
      setStudentFees(res.data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }
  const fetchAttendance = async (studentId) => {
    try {
      setLoading(true)
      const res = await api.getAAttendance(studentId)
      setAllAttendance(res.data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  // Fetch student details first, then attendance
  const fetchData = async () => {
    const studentData = await fetchStudentDetails(id)
    if (studentData && studentData.id) {
      await fetchAttendance(studentData.id)
    }
  }
  //  Using async/await in useEffect
  useEffect(() => {
    if (id) {
      fetchStudentFees(id)

      fetchData()
    }
  }, [id])

  useEffect(() => {
    if (id) {
      fetchStudentDetails(id)
      setFeeForm((prev) => ({ ...prev, student_id: id }))
    }
  }, [id])

  // fee Form change handler - Convert student_id and amount to number
  const handleFeeFormChange = (e) => {
    const { name, value } = e.target

    setFeeForm((prev) => ({
      ...prev,
      [name]:
        name === 'amount' || name === 'student_id' ? Number(value) || 0 : value, // Convert both amount and student_id to number
    }))
  }

  // Updated handleFeeSubmit function with loading state and fee_submit_date

  const handleFeeSubmit = async () => {
    try {
      // Set loading state to true
      setIsSubmittingFee(true)

      if (!feeForm.amount || feeForm.amount <= 0) {
        alert('Please enter a valid amount')
        return
      }

      if (!feeForm.payment_mode) {
        alert('Please select a payment mode')
        return
      }

      // NEW: Add validation for fee_submit_date
      if (!feeForm.fee_submit_date) {
        alert('Please select a fee submission date')
        return
      }

      // Create payload with explicit number conversion, payment_mode, and fee_submit_date
      const feeData = {
        amount: Number(feeForm.amount),
        student_id: Number(feeForm.student_id),
        payment_mode: feeForm.payment_mode,
        remark: feeForm.remark,
        fee_submit_date: new Date(feeForm.fee_submit_date).toISOString(), // Convert to ISO format
      }

      await api.paidFees(feeData)

      toast.success('Fees payment recorded successfully!')
      fetchStudentFees(id)
      setShowFeeForm(false)
      setFeeForm({
        amount: 0,
        student_id: Number(id),
        payment_mode: 'Cash', // Reset to default
        remark: '',
        fee_submit_date: new Date().toISOString().split('T')[0], // Reset to current date
      })
    } catch (error) {
      console.error(error)
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      } else {
        toast.error('Failed to submit fee payment.') // Generic error message
      }
    } finally {
      // Always set loading state to false
      setIsSubmittingFee(false)
    }
  }
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    }).format(amount)
  }

  if (!studentDetails.id) {
    return (
      <div className='min-h-screen bg-gray-50 flex items-center justify-center'>
        <div className='text-center'>
          <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4'></div>
          <p className='text-gray-600'>Loading student details...</p>
        </div>
      </div>
    )
  }

  const handlePrintFee = (fee) => {
    // Helper function to convert number to words
    const numberToWords = (num) => {
      const ones = [
        '',
        'One',
        'Two',
        'Three',
        'Four',
        'Five',
        'Six',
        'Seven',
        'Eight',
        'Nine',
      ]
      const teens = [
        'Ten',
        'Eleven',
        'Twelve',
        'Thirteen',
        'Fourteen',
        'Fifteen',
        'Sixteen',
        'Seventeen',
        'Eighteen',
        'Nineteen',
      ]
      const tens = [
        '',
        '',
        'Twenty',
        'Thirty',
        'Forty',
        'Fifty',
        'Sixty',
        'Seventy',
        'Eighty',
        'Ninety',
      ]

      if (num === 0) return 'Zero'
      if (num < 10) return ones[num]
      if (num < 20) return teens[num - 10]
      if (num < 100)
        return (
          tens[Math.floor(num / 10)] + (num % 10 ? ' ' + ones[num % 10] : '')
        )
      if (num < 1000)
        return (
          ones[Math.floor(num / 100)] +
          ' Hundred' +
          (num % 100 ? ' ' + numberToWords(num % 100) : '')
        )
      if (num < 100000)
        return (
          numberToWords(Math.floor(num / 1000)) +
          ' Thousand' +
          (num % 1000 ? ' ' + numberToWords(num % 1000) : '')
        )
      if (num < 10000000)
        return (
          numberToWords(Math.floor(num / 100000)) +
          ' Lakh' +
          (num % 100000 ? ' ' + numberToWords(num % 100000) : '')
        )
      return (
        numberToWords(Math.floor(num / 10000000)) +
        ' Crore' +
        (num % 10000000 ? ' ' + numberToWords(num % 10000000) : '')
      )
    }

    const generateSlip = (copyType) => {
      return `
      <div class="receipt-slip">
      <div>
         <div class="receipt-header">
          <div class="org-logo">
            <img src="/inflectionORG.webp" height="40px" width="40px" alt="Logo" />
          </div>
          <div class="org-details">
            <h2>INFLECTION ORG PVT LTD</h2>
      <p>The Next Gen Computer & Robotics Institute</p>
                     
          </div>
        </div>
        <div class="receipt-header2" >
                 <h3>FEE RECEIPT</h3>
    <div class="receipt-type">${copyType}</div>
        </div>
</div>
        <div class="receipt-title">
         
          <div class="info-item">
                <span class="label">Date:</span>
                <span class="value">${formatDate(fee.created_at)}</span>
              </div>
          <div class="receipt-no">Receipt No: INF-${fee.receipt_id}</div>
        </div>

        <div class="receipt-body">
          <div class="student-section">
            <h4>Student Information</h4>
            <div class="info-single">
              <div class="info-item">
                <span class="label">Student Name:</span>
                <span class="value">${studentDetails.name || 'N/A'}</span>
              </div>
              <div class="info-item">
                <span class="label">Father's Name:</span>
                <span class="value">${
                  studentDetails.father_name || 'N/A'
                }</span>
              </div>
            </div>
            <div class="info-grid">
              <div class="info-item">
                <span class="label">Enrollment No:</span>
                <span class="value">${
                  studentDetails.enrollment_number || 'N/A'
                }</span>
              </div>
              <div class="info-item">
                <span class="label">Student ID:</span>
                <span class="value">${fee.student_id}</span>
              </div>
              <div class="info-item">
                <span class="label">Class:</span>
                <span class="value">${studentDetails.class || 'N/A'}</span>
              </div>
              <div class="info-item">
                <span class="label">Course:</span>
                <span class="value">${studentDetails.course || 'N/A'}</span>
              </div>
                         </div>
          </div>

          <div class="payment-section">
            <h4>Payment Details</h4>
            <div class="info-grid">
              
             
              <div class="info-item">
                <span class="label">Payment Method:</span>
                <span class="value">${fee.payment_mode}</span>
              </div>
              <div class="info-item">
                <span class="label">Submitted By:</span>
                <span class="value">${fee.user_name}</span>
              </div>
             
            </div>
          </div>

          <div class="fee-breakdown">
            <h4>Fee Breakdown</h4>
            <div class="fee-table">
                          
              <div class="fee-row paid-row">
                <span class="fee-label">Amount Paid:</span>
                <span class="fee-value paid">₹${fee.amount.toLocaleString(
                  'en-IN',
                )}</span>
              </div>
              <div class="fee-row due-row">
                <span class="fee-label">Due Amount:</span>
                <span class="fee-value due">₹${(
                  fee.due_fee || 0
                ).toLocaleString('en-IN')}</span>
              </div>
            </div>
          </div>

         

          
        </div>

        <div class="receipt-footer">
           <p class="iso-cert">An ISO 9001:2015 Certified Company</p>
            <p>Mobile: 8900900815, 9506328878, 7395081624</p>
            <p>Email:team@inflection.org.in</p>
            <p>Near Kanya Purv Vidyalaya, Manaurveer, Khamaria, Bhadohi - 221306</p>
        </div>
      </div>
    `
    }

    const printContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Fee Receipt Print</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Arial', sans-serif;
          font-size: 14px;
          line-height: 1.3;
          color: #333;
        }

        @page {
          size: A4;
          margin: 8mm;
        }

        .print-container {
          width: 194mm;
          height: 281mm;
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-template-rows: 1fr 1fr;
          gap: 3mm;
          padding: 0;
        }

        .receipt-slip {
          border: 2px dashed #333;
          padding: 4mm;
          display: flex;
          flex-direction: column;
          height: 136mm;
          position: relative;
          background: white;
        }

        .receipt-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
                   padding-bottom: 2mm;
          margin-bottom: 2mm;
        }
.receipt-header2 {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          border-bottom: 2px solid #333;
          padding-bottom: 2mm;
          margin-bottom: 2mm;
        }
        .org-logo {
          font-size: 20px;
          color: #2c5aa0;
        }

        .org-details {
          flex: 1;
          text-align: center;
          margin: 0 8px;
        }

        .org-details h2 {
          font-size: 15px;
          color: #2c5aa0;
          font-weight: bold;
          margin-bottom: 2px;
        }

        .org-details p {
          font-size: 12px;
          color: #666;
          margin-bottom: 2px;
          line-height: 1.3;
        }

        .receipt-type {
          font-size: 11px;
          color: #d32f2f;
          font-weight: bold;
          background: #fff;
          border: 1px solid #d32f2f;
          padding: 3px 6px;
          text-align: center;
          min-width: 45px;
        }

        .receipt-title {
          text-align: start;
          display: flex;
          justify-content: space-between;
          margin-bottom: 2mm;
        }

        .receipt-title h3 {
          font-size: 15px;
          color: #d32f2f;
          font-weight: bold;
          margin-bottom: 2px;
        }

        .receipt-no {
          font-size: 11px;
          color: #666;
          background: #f0f0f0;
          padding: 3px 7px;
          display: inline-block;
          border: 1px solid #ccc;
        }

        .receipt-body {
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .student-section,
        .payment-section,
        .fee-breakdown {
          margin-bottom: 2mm;
        }

        .student-section h4,
        .payment-section h4,
        .fee-breakdown h4 {
          font-size: 13px;
          color: #2c5aa0;
          border-bottom: 1px solid #2c5aa0;
          padding-bottom: 1mm;
          margin-bottom: 1.5mm;
        }

        .fee-breakdown {
          background: #f8f9fa;
          border: 1px solid #e1e5e9;
          padding: 2mm;
          border-radius: 1mm;
        }

        .fee-table {
          display: flex;
          flex-direction: column;
          gap: 1mm;
        }

        .fee-row {
          display: flex;
          justify-content: space-between;
          font-size: 11px;
          padding: 2px 0;
          border-bottom: 1px dotted #ddd;
        }

        .fee-row:last-child {
          border-bottom: 2px solid #333;
          font-weight: bold;
          padding-top: 1mm;
        }

        .fee-label {
          font-weight: bold;
          color: #555;
        }

        .fee-value {
          color: #333;
          font-weight: bold;
        }

        .discount {
          color: #28a745;
        }

        .paid {
          color: #007bff;
        }

        .due {
          color: #dc3545;
        }

        .info-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1mm;
        }

        .info-single {
          display: flex;
          flex-direction: column;
          gap: 1mm;
          margin-bottom: 2mm;
        }

        .info-item {
          display: flex;
          justify-content:start;
          font-size: 11px;
          padding: 1px 0;
            border-bottom: 1px dotted #ddd;
        }

        .label {
          font-weight: bold;
          color: #555;
        }

        .value {
          color: #333;
          margin-left:4px;
        }

        .amount-section {
          margin: 1mm 0;
          text-align: center;
        }

        .amount-box {
          background: linear-gradient(135deg, #e8f5e8, #d4edda);
          border: 2px solid #28a745;
          padding: 1.5mm;
          border-radius: 2mm;
        }

        .amount-label {
          font-size: 12px;
          color: #155724;
          font-weight: bold;
          margin-bottom: 2px;
        }

        .amount-value {
          font-size: 18px;
          font-weight: bold;
          color: #155724;
          margin-bottom: 2px;
        }

        .amount-words {
          font-size: 10px;
          color: #155724;
          font-style: italic;
        }

        .signature-section {
          display: flex;
          justify-content: space-between;
          margin: 2mm 0 1mm 0;
        }

        .signature-box {
          text-align: center;
          width: 30%;
        }

        .sign-line {
          border-bottom: 1px solid #333;
          height: 4mm;
          margin-bottom: 1mm;
        }

        .signature-box span {
          font-size: 10px;
          color: #666;
        }

        .receipt-footer {
          border-top: 1px solid #ccc;
          padding-top: 1.5mm;
          text-align: center;
          margin-top: auto;
        }

        .receipt-footer p {
          font-size: 9px;
          color: #666;
          margin-bottom: 1px;
          line-height: 1.3;
        }

          @media print {
          body {
            margin: 0;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .print-container {
            width: 194mm;
            height: 281mm;
            gap: 3mm;
          }

          .receipt-slip {
            height: 136mm;
            padding: 4mm;
          }

          .empty-space {
            height: 136mm;
          }
        }
      </style>
    </head>
    <body>
      <div class="print-container">
        ${generateSlip('Office Copy')}
        ${generateSlip('Student Copy')}
        <div class="empty-space"></div>
        <div class="empty-space"></div>
      </div>
    </body>
    </html>
  `

    // Create print window
    const printWindow = window.open('', '_blank', 'width=900,height=700')

    if (!printWindow) {
      alert('Please allow pop-ups for printing')
      return
    }

    printWindow.document.write(printContent)
    printWindow.document.close()

    // Print after content loads
    printWindow.addEventListener('load', () => {
      setTimeout(() => {
        printWindow.print()

        // Close window after printing
        printWindow.addEventListener('afterprint', () => {
          printWindow.close()
        })

        // Fallback: close after 2 seconds if afterprint doesn't fire
        setTimeout(() => {
          if (!printWindow.closed) {
            printWindow.close()
          }
        }, 2000)
      }, 1000)
    })
  }

  // Open modal with current date
  const handleOpenFeeUpdateModal = (feeId) => {
    setSelectedFeeId(feeId)
    setUpdateFeeDate(new Date().toISOString().split('T')[0]) // Current date in YYYY-MM-DD
    setShowFeeUpdateModal(true)
  }

  // Updated handleUpdateFee function
  const handleUpdateFee = async () => {
    if (!selectedFeeId || !updateFeeDate) {
      toast.error('Please select a date')
      return
    }

    try {
      setLoading(true)
      const updatedFees = {
        fee_submit_date: new Date(updateFeeDate).toISOString(),
      }

      const res = await api.updateFees(selectedFeeId, updatedFees)

      toast.success('Fee updated successfully')
      fetchStudentFees(id)
      setShowFeeUpdateModal(false)
      setSelectedFeeId(null)
      setUpdateFeeDate('')
    } catch (error) {
      console.error(error)
      toast.error(error?.response?.data?.message || 'Failed to update fee')
    } finally {
      setLoading(false)
    }
  }
  // **************card Add and Removed function ****************
  const removedCard = async (id) => {
    try {
      setLoading(true)
      const res = await api.removedCard(id)
      setShowRemovedBtn(false)
      toast.success('removed successfully')
      fetchStudentDetails(id)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }
  const enrolledCard = async (id) => {
    try {
      setLoading(true)
      const res = await api.enrolCard(id)
      toast.success('enrolled Successfully !')
      fetchStudentDetails(id)
    } catch (error) {
      console.error(error)
      toast.error('Failed to enroll card')
    } finally {
      setLoading(false)
    }
  }

  // ***************create Attendance function *******************

  // Current date time ko default value ke liye
  const getCurrentDateTime = () => {
    const now = new Date()
    const date = now.toISOString().split('T')[0] // YYYY-MM-DD format
    const time = now.toTimeString().split(' ')[0].slice(0, 5) // HH:MM format
    return { date, time }
  }

  // Modal open karne par current date time set karna
  const handleOpenModal = () => {
    const { date, time } = getCurrentDateTime()
    setSelectedDate(date)
    setSelectedTime(time)
    setShowModal(true)
  }

  // ISO format mein date time convert karna
  const formatDateTime = (date, time) => {
    // Date: 2025-07-05, Time: 01:30 -> 2025-07-05T01:30:00Z
    return `${date}T${time}:00Z`
  }

  //  createAttendance function
  const createA = async (id) => {
    try {
      setLoading(true)
      const formattedDateTime = formatDateTime(selectedDate, selectedTime)
      const payload = {
        admission_id: id * 1,
        created_at: formattedDateTime,
      }

      const res = await api.createAttendance(payload)

      toast.success('Attendance marked successfully')
      // Fetch updated attendance data
      fetchData()
      setShowModal(false)
    } catch (error) {
      console.error(error)
      toast.error('Failed to mark attendance')
    } finally {
      setLoading(false)
    }
  }
  // Close modal handler
  const handleCloseModal = () => {
    setShowUpdateModal(false)
    setSelectedStudent(null)
  }

  // NEW: Generate Certificate button click handler
  const handleGenerateCertificateClick = (e, student) => {
    e.stopPropagation() // Prevent parent click event
    setSelectedStudent(student)
    setShowCertificateModal(true)
  }
  // NEW: Certificate form submission
  const handleCertificateSubmit = async (formData) => {
    setCertificateLoading(true)
    try {
      // Assuming an API endpoint exists for this in your api.js file
      // e.g., export const generateCertificate = (data) => axios.post('/certificates', data);
      const res = await api.generateCertificate(formData) // You'll need to create this api call
      if (res.status === 200 || res.status === 201) {
        toast.success('Certificate generated successfully!')
        handleCloseModal()
        // Optionally navigate to certificate view page or trigger download
      } else {
        toast.error(
          'Error generating certificate: ' +
            (res.data?.message || res.statusText),
        )
      }
    } catch (error) {
      console.error('Certificate generation error:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to generate certificate',
      )
    } finally {
      setCertificateLoading(false)
    }
  }

  // Edit Registration button click handler
  const handleEditClick = () => {
    setShowUpdateRes(true)
  }
  // Close modal handler
  const handleCloseRes = () => {
    setShowUpdateRes(false)
  }
  const handleUpdateSubmit = async (formData) => {
    setLoading(true)
    try {
      const res = await api.UpdateRegistrationFrom(id, formData)
      if (res.status === 200 || res.status === 201 || res.ok) {
        toast.success('Registration updated successfully!')

        setShowUpdateRes(false)
        await fetchStudentDetails(id)
      } else {
        toast.error(
          'Error updating registration: ' + (res.statusText || 'Unknown error'),
        )
      }
    } catch (error) {
      console.log(error)
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      } else {
        toast.error('Failed to update registration')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='min-h-screen bg-gray-50 py-8 px-4'>
      <div className='max-w-7xl mx-auto'>
        {/* Header */}
        <div className='bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 mb-6 border border-gray-100'>
          <div className='flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6'>
            {/* Student Info Section */}
            <div className='flex items-center space-x-4 group'>
              <div className='relative'>
                <div className='bg-gradient-to-r from-blue-500 to-purple-600 p-3 rounded-full flex-shrink-0 shadow-md group-hover:shadow-lg transition-shadow duration-300'>
                  <User className='h-8 w-8 text-white' />
                </div>
                <div className='absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white shadow-sm'></div>
              </div>

              <div className='min-w-0 flex-1'>
                <h1 className='text-2xl font-bold text-gray-800 truncate bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text'>
                  {studentDetails.name}
                </h1>
                <div className='flex items-center space-x-2 mt-1'>
                  <span className='text-sm text-gray-500'>Enrollment:</span>
                  <span className='text-sm font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded-full'>
                    {studentDetails.enrollment_number}
                  </span>
                </div>
              </div>
            </div>

            {/* Action Buttons Section */}
            <div className='flex flex-col sm:flex-row gap-3 w-full lg:w-auto lg:flex-shrink-0'>
              <div className='flex flex-col sm:flex-row gap-3'>
                {studentDetails.card_id ? (
                  <button
                    onClick={() => setShowRemovedBtn(true)}
                    className='group relative bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-6 py-3 rounded-xl flex items-center justify-center space-x-2 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl'
                  >
                    <IdCardLanyard className='h-5 w-5 group-hover:rotate-12 transition-transform duration-300' />
                    <span className='font-medium'>Card Removed</span>
                    <CheckCircle className='h-4 w-4 opacity-75' />
                  </button>
                ) : (
                  <button
                    onClick={() => enrolledCard(id)}
                    disabled={loading}
                    className={`group relative ${
                      loading
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 transform hover:scale-105'
                    } text-white px-6 py-3 rounded-xl flex items-center justify-center space-x-2 transition-all duration-300 shadow-lg hover:shadow-xl`}
                  >
                    {loading ? (
                      <>
                        <div className='animate-spin rounded-full h-5 w-5 border-b-2 border-white'></div>
                        <span className='font-medium'>Enrolling...</span>
                      </>
                    ) : (
                      <>
                        <IdCardLanyard className='h-5 w-5 group-hover:rotate-12 transition-transform duration-300' />
                        <span className='font-medium'>Enroll Card</span>
                      </>
                    )}
                  </button>
                )}

                {/* Fee Payment Button */}
                <button
                  onClick={() => setShowFeeForm(true)}
                  className='group relative bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white px-6 py-3 rounded-xl flex items-center justify-center space-x-2 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl'
                >
                  <IndianRupee className='h-5 w-5 group-hover:bounce transition-all duration-300' />
                  <span className='font-medium whitespace-nowrap'>
                    Fee Payment
                  </span>
                </button>
              </div>

              <button
                onClick={handleOpenModal}
                className='group relative bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white px-6 py-3 rounded-xl flex items-center justify-center space-x-2 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl'
              >
                <Clock className='h-5 w-5 group-hover:rotate-12 transition-transform duration-300' />
                <span className='font-medium whitespace-nowrap'>
                  Mark Attendance
                </span>
              </button>

              {showModal && (
                <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
                  <div className='bg-white rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl'>
                    <div className='flex justify-between items-center mb-6'>
                      <h2 className='text-2xl font-bold text-gray-800 flex items-center'>
                        <Calendar className='h-6 w-6 mr-2 text-orange-500' />
                        Select Date & Time
                      </h2>
                      <button
                        onClick={() => setShowModal(false)}
                        className='text-gray-500 hover:text-gray-700 transition-colors'
                      >
                        <X className='h-6 w-6' />
                      </button>
                    </div>

                    <div className='mb-6'>
                      <label className='block text-sm font-medium text-gray-700 mb-2'>
                        Date
                      </label>
                      <input
                        type='date'
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        className='w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200'
                      />
                    </div>

                    <div className='mb-8'>
                      <label className='block text-sm font-medium text-gray-700 mb-2'>
                        Time
                      </label>
                      <input
                        type='time'
                        value={selectedTime}
                        onChange={(e) => setSelectedTime(e.target.value)}
                        className='w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200'
                      />
                    </div>

                    <div className='mb-6 p-4 bg-gray-50 rounded-xl'>
                      <p className='text-sm text-gray-600 mb-1'>Preview:</p>
                      <p className='font-mono text-sm text-gray-800'>
                        {selectedDate && selectedTime
                          ? formatDateTime(selectedDate, selectedTime)
                          : 'Please select date and time'}
                      </p>
                    </div>

                    <div className='flex space-x-3'>
                      <button
                        onClick={() => setShowModal(false)}
                        className='flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors duration-200'
                      >
                        Cancel
                      </button>
                      <button
                        onClick={() => createA(id)}
                        disabled={!selectedDate || !selectedTime}
                        className='flex-1 px-6 py-3 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white rounded-xl disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200'
                      >
                        Mark Attendance
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <button
                onClick={(e) =>
                  handleGenerateCertificateClick(e, studentDetails)
                }
                disabled={studentDetails.certificate_generated}
                className='group relative bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white px-6 py-3 rounded-xl flex items-center justify-center space-x-2 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl '
              >
                <span className='font-medium'>Create Certificate</span>
              </button>
            </div>
          </div>

          {/* Status Indicators */}
          <div className='mt-4 pt-4 border-t border-gray-100'>
            <div className='flex items-center justify-between'>
              <div className='flex flex-wrap gap-2'>
                <span className='inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800'>
                  <div className='w-2 h-2 bg-green-500 rounded-full mr-2'></div>
                  {studentDetails.status}
                </span>
                <span className='inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800'>
                  <div className='w-2 h-2 bg-blue-500 rounded-full mr-2'></div>
                  2025 Batch
                </span>
                {!studentDetails.card_id && (
                  <span className='inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800'>
                    <div className='w-2 h-2 bg-yellow-500 rounded-full mr-2'></div>
                    Card Pending
                  </span>
                )}
              </div>
              <button
                onClick={() => handleEditClick()}
                className='bg-blue-500 hover:bg-blue-600 text-white text-xs px-2 py-1 rounded transition-colors'
              >
                Edit
              </button>
            </div>
          </div>
        </div>

        {/* Student Details Grid */}
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
          {/* Personal Information */}
          <div className='bg-white rounded-lg shadow-md p-6'>
            <h2 className='text-xl font-semibold text-gray-800 mb-4 flex items-center'>
              <User className='h-5 w-5 mr-2 text-blue-600' />
              Personal Information
            </h2>
            <div className='space-y-4'>
              <div className='flex items-center space-x-3'>
                <User className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Student Name</p>
                  <p className='font-medium'>{studentDetails.name}</p>
                </div>
              </div>
              <div className='flex items-center space-x-3'>
                <User className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Father's Name</p>
                  <p className='font-medium'>{studentDetails.father_name}</p>
                </div>
              </div>
              <div className='flex items-center space-x-3'>
                <Phone className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Phone Number</p>
                  <p className='font-medium'>{studentDetails.phone_number}</p>
                </div>
              </div>
              <div className='flex items-center space-x-3'>
                <MapPin className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Address</p>
                  <p className='font-medium'>{studentDetails.address}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Academic Information */}
          <div className='bg-white rounded-lg shadow-md p-6'>
            <h2 className='text-xl font-semibold text-gray-800 mb-4 flex items-center'>
              <GraduationCap className='h-5 w-5 mr-2 text-blue-600' />
              Academic Information
            </h2>
            <div className='space-y-4'>
              <div className='flex items-center space-x-3'>
                <Hash className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Enrollment Number</p>
                  <p className='font-medium'>
                    {studentDetails.enrollment_number}
                  </p>
                </div>
              </div>
              <div className='flex items-center space-x-3'>
                <GraduationCap className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Class</p>
                  <p className='font-medium'>{studentDetails.class}</p>
                </div>
              </div>
              <div className='flex items-center space-x-3'>
                <GraduationCap className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Course</p>
                  <p className='font-medium'>{studentDetails.course}</p>
                </div>
              </div>
              <div className='flex items-center space-x-3'>
                <GraduationCap className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Semester</p>
                  <p className='font-medium'>{studentDetails.semester}</p>
                </div>
              </div>
              <div className='flex items-center space-x-3'>
                <GraduationCap className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>School/College</p>
                  <p className='font-medium'>
                    {studentDetails.school_or_college_name}
                  </p>
                </div>
              </div>
              <div className='flex items-center space-x-3'>
                <GraduationCap className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Subject/Stream</p>
                  <p className='font-medium'>
                    {studentDetails.subject_or_stream}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Fee Information */}
          <div className='bg-white rounded-lg shadow-md p-6'>
            <h2 className='text-xl font-semibold text-gray-800 mb-4 flex items-center'>
              <IndianRupee className='h-5 w-5 mr-2 text-blue-600' />
              Fee Information
            </h2>
            <div className='space-y-4'>
              <div className='flex items-center space-x-3'>
                <IndianRupee className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Total Fee</p>
                  <p className='font-medium text-lg'>
                    {formatCurrency(studentDetails.fee)}
                  </p>
                </div>
              </div>
              <div className='flex items-center space-x-3'>
                <IndianRupee className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Discount</p>
                  <p className='font-medium text-green-600'>
                    {formatCurrency(studentDetails.discount)}
                  </p>
                </div>
              </div>
              <div className='flex items-center space-x-3'>
                <IndianRupee className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Net Amount</p>
                  <p className='font-medium text-lg text-blue-600'>
                    {formatCurrency(
                      studentDetails.fee - studentDetails.discount,
                    )}
                  </p>
                </div>
              </div>

              {studentDetails.due_fee && (
                <div className='flex items-center space-x-3'>
                  <IndianRupee className='h-4 w-4 text-gray-500' />
                  <div>
                    <p className='text-sm text-gray-500'>Due</p>
                    <p className='font-medium text-red-500 text-lg'>
                      {studentDetails.due_fee}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* System Information */}
          <div className='bg-white rounded-lg shadow-md p-6'>
            <h2 className='text-xl font-semibold text-gray-800 mb-4 flex items-center'>
              <Calendar className='h-5 w-5 mr-2 text-blue-600' />
              System Information
            </h2>
            <div className='space-y-4'>
              <div className='flex items-center space-x-3'>
                <Calendar className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Created At</p>
                  <p className='font-medium'>
                    {formatDate(studentDetails.created_at)}
                  </p>
                </div>
              </div>
              <div className='flex items-center space-x-3'>
                <Calendar className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Last Updated</p>
                  <p className='font-medium'>
                    {formatDate(studentDetails.updated_at)}
                  </p>
                </div>
              </div>
              <div className='flex items-center space-x-3'>
                <User className='h-4 w-4 text-gray-500' />
                <div>
                  <p className='text-sm text-gray-500'>Submitted By</p>
                  <p className='font-medium'>
                    User ID: {studentDetails.submitted_by}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* fees history */}
      <div className='max-w-7xl mx-auto mt-4 my-8'>
        {/* Student Fees Section */}
        <div className='bg-white rounded-lg shadow-md p-6'>
          <div className='flex justify-between items-center mb-6'>
            <h2 className='text-2xl font-bold text-gray-800 flex items-center'>
              <IndianRupee className='mr-2' />
              Fees History
            </h2>
          </div>

          {/* Fees List */}

          {studentFees.length > 0 ? (
            <div className='space-y-4'>
              {studentFees.map((fee) => (
                <div
                  key={fee.id}
                  className='border border-gray-200 rounded-lg p-4 hover:shadow-sm transition-shadow'
                >
                  <div className='grid grid-cols-1 md:grid-cols-5 gap-4'>
                    {/* Amount */}
                    <div className='flex items-center'>
                      <IndianRupee className='text-green-600 mr-2 h-5 w-5' />
                      <div>
                        <p className='text-sm text-gray-600'>Amount</p>
                        <p className='font-semibold text-lg text-green-600'>
                          ₹{fee.amount}
                        </p>
                      </div>
                    </div>

                    {/* Submitted Date */}
                    <div className='flex items-center'>
                      <Calendar className='text-blue-600 mr-2 h-5 w-5' />
                      <div>
                        <p className='text-sm text-gray-600'>Submitted Date</p>
                        <p className='font-medium'>
                          {formatDate(fee.fee_submit_date)}
                        </p>
                      </div>
                    </div>

                    {/* Fee ID */}
                    <div className='flex items-center'>
                      <Hash className='text-gray-600 mr-2 h-5 w-5' />
                      <div>
                        <p className='text-sm text-gray-600'>Fee ID</p>
                        <p className='font-medium'>#{fee.id}</p>
                      </div>
                    </div>

                    {/* Submitted By */}
                    <div className='flex items-center'>
                      <User className='text-purple-600 mr-2 h-5 w-5' />
                      <div>
                        <p className='text-sm text-gray-600'>Submitted By</p>
                        <p className='font-medium'>User #{fee.user_name}</p>
                      </div>
                    </div>

                    {/* Print Button */}
                    <div className='flex items-center gap-1 justify-end'>
                      <button
                        onClick={() => handleOpenFeeUpdateModal(fee.id)}
                        className='bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors'
                      >
                        <span>Fee Update</span>
                      </button>
                      <button
                        onClick={() => handlePrintFee(fee)}
                        className='bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors'
                      >
                        <Printer className='h-4 w-4' />
                        <span>Print</span>
                      </button>
                    </div>
                  </div>

                  {/* Additional Info Section */}
                  <div className='grid grid-cols-1 md:grid-cols-3 gap-4 mt-4 text-sm text-gray-700'>
                    <p>
                      <span className='font-medium'>Enrollment No:</span>{' '}
                      {fee.enrollment_number}
                    </p>
                    <p>
                      <span className='font-medium'>Student Name:</span>{' '}
                      {fee.student_name || fee.name}
                    </p>
                    <p>
                      <span className='font-medium'>Father Name:</span>{' '}
                      {fee.father_name}
                    </p>
                    <p>
                      <span className='font-medium'>Class:</span>{' '}
                      {fee.class || 'N/A'}
                    </p>
                    <p>
                      <span className='font-medium'>Course:</span>{' '}
                      {fee.course || 'N/A'}
                    </p>
                    <p>
                      <span className='font-medium'>Total Fees:</span>
                      {fee.discount && fee.discount > 0 ? (
                        <>
                          <del className='text-gray-500 mr-2'>
                            ₹{fee.total_fee || 'N/A'}
                          </del>
                          <span className='text-green-600 font-semibold'>
                            ₹{fee.total_fee - fee.discount || 'N/A'}
                          </span>
                          <span className='text-sm text-green-600 ml-2'>
                            (₹{fee.discount} discount applied)
                          </span>
                        </>
                      ) : (
                        <span>₹{fee.total_fee || 'N/A'}</span>
                      )}
                    </p>

                    <p>
                      <span className='font-medium'>Total Paid:</span> ₹
                      {fee.paid_fees || fee.amount || 0}
                    </p>
                    <p>
                      <span className='font-medium'>Due Fees:</span> ₹
                      {fee.due_fee || 0}
                    </p>
                    <p>
                      <span className='font-medium'>Payment Mode:</span>{' '}
                      {fee.payment_mode || 'N/A'}
                    </p>
                    <p>
                      <span className='font-medium'>Phone:</span>{' '}
                      {fee.phone_number || 'N/A'}
                    </p>
                    <p>
                      <span className='font-medium'>Remark:</span>{' '}
                      {fee.remark || 'N/A'}
                    </p>
                    <p>
                      <span className='font-medium'>Address:</span>{' '}
                      {fee.address || 'N/A'}
                    </p>
                    <p>
                      <span className='font-medium'>School/College:</span>{' '}
                      {fee.school_or_college_name || 'N/A'}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className='text-center py-8'>
              <IndianRupee className='mx-auto h-12 w-12 text-gray-400 mb-4' />
              <p className='text-gray-600'>No fees recorded yet</p>
            </div>
          )}

          {/* Total Amount */}
          {studentFees.length > 0 && (
            <div className='mt-6 pt-4 border-t border-gray-200'>
              <div className='flex justify-between items-center'>
                <span className='text-lg font-semibold text-gray-800'>
                  Total Fees Paid:
                </span>
                <span className='text-2xl font-bold text-green-600'>
                  ₹{studentFees.reduce((total, fee) => total + fee.amount, 0)}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* attendance calender */}
      <div className='max-w-7xl mx-auto space-y-8'>
        <div className='bg-white rounded-lg shadow-lg p-4'>
          <h1 className='text-2xl font-bold text-gray-800 mb-6 text-center'>
            Attendance Calendar with Month
          </h1>

          {/* Stats */}
          <div className='mb-6 grid grid-cols-1 md:grid-cols-3 gap-4'>
            <div className='bg-blue-50 p-4 rounded-lg text-center'>
              <div className='text-2xl font-bold text-blue-600'>
                {allAttendance.length}
              </div>
              <div className='text-sm text-gray-600'>Total Attendance</div>
            </div>

            <div className='bg-purple-50 p-4 rounded-lg text-center'>
              <div className='text-2xl font-bold text-purple-600'>
                {
                  new Set(
                    allAttendance.map((att) =>
                      new Date(att.created_at).toDateString(),
                    ),
                  ).size
                }
              </div>
              <div className='text-sm text-gray-600'>Days Present</div>
            </div>
          </div>

          {/* Calendar */}
          <div className='bg-white rounded-lg overflow-hidden'>
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              initialView='dayGridMonth'
              headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay',
              }}
              events={events}
              eventClick={handleEventClick}
              dateClick={handleDateClick}
              height='auto'
              eventTimeFormat={{
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              }}
              eventDisplay='block'
              dayMaxEvents={3}
              moreLinkClick='popover'
              eventMouseEnter={(mouseEnterInfo) => {
                mouseEnterInfo.el.style.cursor = 'pointer'
              }}
              eventClassNames='cursor-pointer'
              dayCellClassNames='hover:bg-gray-50'
              eventDidMount={(info) => {
                info.el.setAttribute(
                  'title',
                  `Click for details - Time: ${info.event.extendedProps.time}`,
                )
              }}
            />
          </div>

          {/* Recent Attendance */}
          <div className='mt-6'>
            <h2 className='text-lg font-semibold text-gray-800 mb-4'>
              Recent Attendance
            </h2>
            <div className='bg-gray-50 rounded-lg p-4'>
              <div className='space-y-2'>
                {allAttendance.slice(0, 5).map((attendance) => (
                  <div
                    key={attendance.id}
                    className='flex justify-between items-center py-2 border-b border-gray-200 last:border-b-0'
                  >
                    <div>
                      <span className='font-medium text-gray-800'>
                        Admission ID: {attendance.admission_id}
                      </span>
                      <span className='text-sm text-gray-500 ml-2'>
                        (ID: {attendance.id})
                      </span>
                    </div>
                    <div className='text-sm text-gray-600'>
                      {new Date(attendance.created_at).toLocaleString()}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Fee Payment Modal form */}
      {showFeeForm && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50'>
          <div className='bg-white rounded-lg shadow-xl max-w-md w-full p-6'>
            <div className='flex items-center justify-between mb-4'>
              <h3 className='text-xl font-semibold text-gray-800'>
                Deposit Fee Payment
              </h3>
              <button
                onClick={() => setShowFeeForm(false)}
                className='text-gray-400 hover:text-gray-600'
                disabled={isSubmittingFee}
              >
                <X className='h-6 w-6' />
              </button>
            </div>
            <div className='space-y-4'>
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  Student ID
                </label>
                <input
                  type='number'
                  name='student_id'
                  value={feeForm.student_id}
                  onChange={handleFeeFormChange}
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50'
                  readOnly
                  disabled
                />
              </div>

              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  Amount *
                </label>
                <input
                  type='text'
                  name='amount'
                  value={feeForm.amount}
                  onChange={handleFeeFormChange}
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-50 disabled:cursor-not-allowed'
                  placeholder='Enter amount'
                  required
                  disabled={isSubmittingFee}
                />
              </div>

              {/* New Payment Mode Dropdown */}
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  Payment Mode *
                </label>
                <select
                  name='payment_mode'
                  value={feeForm.payment_mode}
                  onChange={handleFeeFormChange}
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white disabled:bg-gray-50 disabled:cursor-not-allowed'
                  required
                  disabled={isSubmittingFee}
                >
                  <option value='Cash'>Cash</option>
                  <option value='UPI J'>UPI (J)</option>
                  <option value='UPI Current'>UPI (Current)</option>
                  <option value='UPI Self'>UPI (Self)</option>
                </select>
              </div>

              {/* NEW: Fee Submission Date Input */}
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  Date of Payment *
                </label>
                <input
                  type='date' // Use type='date' for date picker
                  name='fee_submit_date'
                  value={feeForm.fee_submit_date}
                  onChange={handleFeeFormChange}
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white disabled:bg-gray-50 disabled:cursor-not-allowed'
                  required
                  disabled={isSubmittingFee}
                />
              </div>

              {/* Remark */}
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  Remark
                </label>
                <input
                  type='text'
                  name='remark'
                  value={feeForm.remark}
                  onChange={handleFeeFormChange}
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-50 disabled:cursor-not-allowed'
                  placeholder='Remark'
                  disabled={isSubmittingFee}
                />
              </div>

              <div className='flex space-x-3 pt-4'>
                <button
                  type='button'
                  onClick={() => setShowFeeForm(false)}
                  className='flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
                  disabled={isSubmittingFee}
                >
                  Cancel
                </button>
                <button
                  type='button'
                  onClick={handleFeeSubmit}
                  className='flex-1 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-green-600 flex items-center justify-center space-x-2'
                  disabled={isSubmittingFee}
                >
                  {isSubmittingFee ? (
                    <>
                      <svg
                        className='animate-spin h-4 w-4 text-white'
                        xmlns='http://www.w3.org/2000/svg'
                        fill='none'
                        viewBox='0 0 24 24'
                      >
                        <circle
                          className='opacity-25'
                          cx='12'
                          cy='12'
                          r='10'
                          stroke='currentColor'
                          strokeWidth='4'
                        ></circle>
                        <path
                          className='opacity-75'
                          fill='currentColor'
                          d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
                        ></path>
                      </svg>
                      <span>Processing...</span>
                    </>
                  ) : (
                    'Pay'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/*Removed Card modal form  */}
      {showRemovedBtn && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
          <div className='bg-white rounded-2xl shadow-xl p-6 w-full max-w-sm text-center space-y-4'>
            <h2 className='text-xl font-semibold text-gray-800'>
              Are you sure?
            </h2>
            <p className='text-gray-600'>
              Do you really want to remove this card?
            </p>

            <div className='flex justify-center gap-4'>
              <button
                onClick={() => removedCard(id)}
                className='bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition duration-200'
              >
                Yes, Remove
              </button>
              <button
                onClick={() => setShowRemovedBtn(false)}
                className='bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition duration-200'
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* NEW: Generate Certificate Modal */}
      {showCertificateModal && selectedStudent && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4'>
          <div className='bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto'>
            <div className='flex justify-between items-center p-4 bg-green-500 border-b border-gray-200'>
              <h2 className='text-2xl font-bold text-white'>
                Generate Certificate for - {selectedStudent.name}
              </h2>
              <button
                onClick={handleCloseModal}
                className='text-white hover:text-red-500 text-2xl font-bold'
                disabled={certificateLoading}
              >
                ×
              </button>
            </div>
            <div className='p-6'>
              <GenerateCertificateForm
                initialData={selectedStudent}
                onSubmit={handleCertificateSubmit}
                loading={certificateLoading}
                onCancel={handleCloseModal}
              />
            </div>
          </div>
        </div>
      )}

      {showFeeUpdateModal && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
          <div className='bg-white rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl'>
            <div className='flex justify-between items-center mb-6'>
              <h2 className='text-2xl font-bold text-gray-800 flex items-center'>
                <Calendar className='h-6 w-6 mr-2 text-blue-500' />
                Update Fee Date
              </h2>
              <button
                onClick={() => setShowFeeUpdateModal(false)}
                className='text-gray-500 hover:text-gray-700 transition-colors'
                disabled={loading}
              >
                <X className='h-6 w-6' />
              </button>
            </div>

            <div className='mb-6'>
              <label className='block text-sm font-medium text-gray-700 mb-2'>
                Select New Fee Submission Date
              </label>
              <input
                type='date'
                value={updateFeeDate}
                onChange={(e) => setUpdateFeeDate(e.target.value)}
                className='w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200'
                disabled={loading}
              />
            </div>

            <div className='mb-6 p-4 bg-gray-50 rounded-xl'>
              <p className='text-sm text-gray-600 mb-1'>Preview:</p>
              <p className='font-mono text-sm text-gray-800'>
                {updateFeeDate
                  ? new Date(updateFeeDate).toLocaleDateString('en-IN', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })
                  : 'Please select a date'}
              </p>
            </div>

            <div className='flex space-x-3'>
              <button
                onClick={() => setShowFeeUpdateModal(false)}
                className='flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors duration-200'
                disabled={loading}
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateFee}
                disabled={!updateFeeDate || loading}
                className='flex-1 px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-xl disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 flex items-center justify-center'
              >
                {loading ? (
                  <>
                    <div className='animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2'></div>
                    Updating...
                  </>
                ) : (
                  'Update Fee Date'
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Update Registration Modal */}
      {showUpdateRes && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4'>
          <div className='bg-white rounded-lg max-w-6xl w-full max-h-[90vh] overflow-y-auto'>
            <div className='flex justify-between items-center p-4 bg-blue-500 border-b border-gray-200'>
              <h2 className='text-2xl font-bold text-white'>
                Update Registration
              </h2>
              <button
                onClick={handleCloseRes}
                className='text-white hover:text-red-500 text-2xl font-bold'
                // disabled={updateLoading}
              >
                ×
              </button>
            </div>

            <div className='p-6'>
              <UpdateRegistration
                initialData={studentDetails}
                onSubmit={handleUpdateSubmit}
                loading={loading}
                onCancel={handleCloseRes}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Details
